import { render, staticRenderFns } from "./ActionPaymentConfirmation.vue?vue&type=template&id=18f531ab"
import script from "./ActionPaymentConfirmation.vue?vue&type=script&lang=js"
export * from "./ActionPaymentConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports